import {
    PERSONAL_ROOM_ACTIVATED_NOTIFICATION,
    SHOWROOM_ACTIVATED_NOTIFICATION,
    RELOAD_PAGE_NOTIFICATION,
    SERVICE_MESSAGE
} from '../constants/serviceMessage';

import {
    ROOM_TYPE_PERMANENT
} from '../constants/rooms';

import {BobTVUser} from '../components/bobtv-neo/BobTVUser/index';

const serviceMessagesMiddleware = (store) => (next) => (action) => {
    if (action.type == SERVICE_MESSAGE) {
        let {currentRoom, users} = store.getState();

        if(action.message.data.sender) {
            let {
                sender,
                receiver
            } = action.message.data;

            let senderUser = users.get({nick: sender});
            let receiverUser = users.get({nick: receiver});

            action.message.data.senderUser = senderUser;
            action.message.data.receiverUser = receiverUser;
        }

        // skipping Personal room notification for non-permanent
        if (action.message.type == PERSONAL_ROOM_ACTIVATED_NOTIFICATION) {
            if (currentRoom.type != ROOM_TYPE_PERMANENT) {
                return;
            }

            let newAction = Object.assign({}, action);
            newAction.message.data.creator = new BobTVUser(action.message.data.creator);

            return next(newAction);
        }

        if (action.message.type == SHOWROOM_ACTIVATED_NOTIFICATION) {
            let newAction = Object.assign({}, action);
            newAction.message.data.creator = new BobTVUser(action.message.data.creator);

            return next(newAction);
        }

        if (action.message.type == RELOAD_PAGE_NOTIFICATION) {
            store.dispatch({type: RELOAD_PAGE_NOTIFICATION});
        }
    }

    next(action)
};

export default serviceMessagesMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/serviceMessages.js